export default "__VITE_ASSET__DArDxWuc__"